import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';
import { LoadableLazy } from '@confluence/loadable';
import React from 'react';

const TrialFlagsLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TrialComponentsFlags" */ '../src/TrialFlags/TrialFlags'
			)
		).TrialFlags,
});

export const TrialFlags = withErrorBoundary({
	attribution: Attribution.GROWTH_LUNA,
})(() => <TrialFlagsLoadable />);
